import axios from 'axios';
import _ from 'lodash';

export const getUserList = ({ page, limit }) => {
  const params = {
    page,
    limit,
  };
  return axios.get('/cms/user/list', { params }).then((res) => {
    if (res.data.code === 0) {
      return _.get(res, 'data.data', []);
    }
  });
};

export const getUserById = (id) => {
  return axios.get(`/cms/user/${id}`).then((res) => {
    if (res.data.code === 0) {
      return _.get(res, 'data.data', null);
    }
  });
};

export const getUserTransactionList = ({
  playerId,
  page,
  limit,
  fromTime,
  toTime,
  ticketId,
  transactionId,
  providerTransactionId,
  roundId,
  userToken,
  logTime,
  providerCode,
}) => {
  const params = {
    page,
    limit,
    ...(fromTime ? { from_time: fromTime } : {}),
    ...(toTime ? { to_time: toTime } : {}),
    ...(ticketId ? { ticket_id: ticketId } : {}), // match Go struct
    ...(transactionId ? { transaction_id: transactionId } : {}),
    ...(providerTransactionId ? { provider_transaction_id: providerTransactionId } : {}),
    ...(roundId ? { round_id: roundId } : {}),
    ...(userToken ? { user_token: userToken } : {}),
    ...(logTime ? { log_time: logTime } : {}),
    ...(providerCode ? { provider_code: providerCode } : {}),
  };

  console.log('request params ->', params);

  return axios.get(`/cms/report/player/${playerId}/transaction/history`, { params }).then((res) => {
    if (res.data.code === 0) {
      return _.get(res, 'data.data', []);
    }
    return [];
  });
};

export const updateUser = (id, data) => {
  return axios.put(`/cms/user/${id}`, data).then((res) => res.data.data);
};

export const createUser = (data) => {
  return axios.post('/cms/user', data).then((res) => res.data.data);
};

export const deleteUser = (id) => {
  return axios.delete(`/cms/user/${id}`).then((res) => res.data.data);
};
